export default __webpack_public_path__ + "static/media/abdominal.099b4cee.jpg";